import { useEffect, useState } from "react";
import api from "@/lib/api";
import { ArrowRight, GitCompareArrows } from "lucide-react";

export default function AmendmentDiff({ contractId }) {
  const [diff, setDiff] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get(`/contracts/${contractId}/diff`)
      .then(r => setDiff(r.data))
      .catch(e => setErr(e?.response?.data?.detail || "No parent to diff"));
  }, [contractId]);

  if (err) return <div className="text-xs text-slate-500 p-4">{err}</div>;
  if (!diff) return <div className="text-xs text-slate-500 p-4">Loading diff...</div>;

  return (
    <div className="bg-white border border-slate-200 rounded-md" data-testid="amendment-diff">
      <div className="px-4 py-3 border-b border-slate-100 flex items-center gap-2">
        <GitCompareArrows className="w-4 h-4 text-[#005289]" />
        <div className="text-xs font-bold uppercase tracking-wider text-slate-500">
          Amendment Diff · {diff.change_count} field{diff.change_count !== 1 ? "s" : ""} changed
        </div>
        <div className="ml-auto text-[11px] text-slate-500 font-mono">
          {diff.parent.contract_number} → {diff.amendment.contract_number}
        </div>
      </div>
      <table className="hcd-table">
        <thead>
          <tr>
            <th style={{ width: "22%" }}>Field</th>
            <th style={{ width: "36%" }}>Before (Parent)</th>
            <th style={{ width: "6%" }}></th>
            <th style={{ width: "36%" }}>After (Amendment)</th>
          </tr>
        </thead>
        <tbody>
          {diff.rows.map((r, i) => (
            <tr key={i} className={r.changed ? "bg-amber-50" : ""} data-testid={`diff-${r.field.replace(/\s+/g, "-")}`}>
              <td className="font-semibold">{r.field}</td>
              <td className={`text-slate-600 ${r.changed ? "line-through" : ""}`}>{String(r.before ?? "—")}</td>
              <td className="text-center text-slate-300">{r.changed ? <ArrowRight className="w-3 h-3 inline" /> : "="}</td>
              <td className={`${r.changed ? "font-bold text-[#005289]" : "text-slate-600"}`}>{String(r.after ?? "—")}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
